"use client";

import ErrorPage from "@frontend/components/error/ErrorPage";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <ErrorPage
      error={error}
      reset={reset}
      redirectUrl="/"
      redirectText="Go Home"
      showImage={true}
      showSupport={false}
    />
  );
}
